import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { Indicator } from '~/api/timeseries/timeseries-schema';
import { ChartWidgets } from '~/components/chart-widgets/ChartWidgets';
import { OverlayModal } from '~/components/overlay-modal/OverlayModal';

import * as S from './IndicatorsWidget.styles';

interface IndicatorsWidgetModalProps {
  handleClose: () => void;
}

const getActiveIndicator = (searchParams: URLSearchParams) =>
  (searchParams.get('indicator') as Indicator | null) ?? Indicator.TLI;

export const IndicatorsWidget = ({
  handleClose,
}: IndicatorsWidgetModalProps) => {
  const { t } = useTranslation(['indicator', 'chat']);
  const [searchParams] = useSearchParams();
  const [activeIndicator, setActiveIndicator] = useState<Indicator>(() =>
    getActiveIndicator(searchParams)
  );

  useEffect(() => {
    if (searchParams) {
      const indicator = getActiveIndicator(searchParams);
      setActiveIndicator(indicator);
    }
  }, [searchParams]);

  return (
    <OverlayModal
      onClose={handleClose}
      title={
        /* i18next-extract-mark-context-next-line ["TLI", "RFI", "PI", "TI"] */
        t('indicator:title.text', {
          context: activeIndicator,
        })
      }
    >
      <ChartWidgets />

      <S.Description>
        {
          /* i18next-extract-mark-context-next-line ["TLI", "RFI", "PI", "TI"] */
          t('indicator:description.text', {
            context: activeIndicator,
          })
        }
      </S.Description>
    </OverlayModal>
  );
};
